import { OptionItem } from "../../../../types";
import { ColumnOption, IActivityColumnDataColumn } from "./types";

export const DEFAULT_DATE_LABEL = "ThisWeek";

export const GROUP_BY_OPTIONS: OptionItem[] = [
  { label: "Group by: All", value: "None" },
  { label: "Group by: Team", value: "Team" },
  { label: "Group by: Site", value: "Site" },
];

export const MEASURE_BY_OPTIONS: OptionItem[] = [
  { label: "Who Logged Call Result", value: "user_id" },
  { label: "Who Set Original Demo", value: "set_user_id" },
];

export const MANAGE_TABLE_COLUMN_OPTIONS: ColumnOption[] = [
  { metric_label: "Time of Call", metric: "CallTime", fixed: false },
  { metric_label: "Contact Name", metric: "LeadName", fixed: false },
  { metric_label: "Business Name", metric: "BusinessName", fixed: false },
  { metric_label: "Sales Rep", metric: "RepName", fixed: false },
  { metric_label: "Call Result", metric: "CallResult", fixed: false },
  { metric_label: "Associated Action", metric: "AssociatedAction", fixed: false },
  { metric_label: "Set", metric: "Set", fixed: true },
  { metric_label: "Held", metric: "Held", fixed: true },
  { metric_label: "Closed", metric: "Close", fixed: true },
  { metric_label: "Time of Event", metric: "EventTime", fixed: false },
  { metric_label: "Sales Rep Who Set Demo", metric: "SetByUser", fixed: false },
  { metric_label: "Sales Rep Who made the Sale", metric: "ClosedByUser", fixed: false },
  { metric_label: "Industry", metric: "Industry", fixed: false },
  { metric_label: "Sub-Industry", metric: "SubIndustry", fixed: false },
  { metric_label: "Lead Source", metric: "LeadSource", fixed: false },
  { metric_label: "Revenue", metric: "Revenue", fixed: false },
  { metric_label: "Revenue Value", metric: "RevenueValue", fixed: false },
  { metric_label: "Recurring Revenue", metric: "RecurringRevenue", fixed: false },
  { metric_label: "Days Set Out", metric: "DaysSetOut", fixed: false },
  { metric_label: "Dials: Current Sales Cycle", metric: "DialsInCurrentSalesCycle", fixed: false },
  { metric_label: "Call End Reason", metric: "CallEndReason", fixed: false },
  { metric_label: "Date/Time Sms Replied", metric: "DateTimeSmsReplied", fixed: false },
  { metric_label: "Date/Time Sms Sent", metric: "DateTimeSmsSent", fixed: false },
  { metric_label: "Date/Time Email Replied", metric: "DateTimeEmailReplied", fixed: false },
  { metric_label: "Date/Time Email Sent", metric: "DateTimeEmailSent", fixed: false },
  { metric_label: "Product(s) Sold", metric: "ProductsSold", fixed: false },
];

export const EVENT_COLUMN_DATA = [
  { metric_label: "Time of Call", metric: "CallTime", fixed: false },
  { metric_label: "Event Type", metric: "EventType", fixed: false },
  { metric_label: "Contact Name", metric: "LeadName", fixed: false },
  { metric_label: "Business Name", metric: "BusinessName", fixed: false },
  { metric_label: "Sales Rep", metric: "RepName", fixed: false },
  { metric_label: "Set", metric: "Set", fixed: true },
  { metric_label: "Held", metric: "Held", fixed: true },
  { metric_label: "Closed", metric: "Close", fixed: true },
  { metric_label: "Time of Event", metric: "EventTime", fixed: false },
  { metric_label: "Sales Rep Who Set Demo", metric: "SetByUser", fixed: false },
  { metric_label: "Sales Rep Who made the Sale", metric: "ClosedByUser", fixed: false },
  { metric_label: "Industry", metric: "Industry", fixed: false },
  { metric_label: "Sub-Industry", metric: "SubIndustry", fixed: false },
  { metric_label: "Lead Source", metric: "LeadSource", fixed: false },
  { metric_label: "Call Result", metric: "ScheduleItemCallResult", fixed: false },
  { metric_label: "Days Set Out", metric: "DaysSetOut", fixed: false },
  { metric_label: "Dials: Current Sales Cycle", metric: "DialsInCurrentSalesCycle", fixed: false },
];

export const TRANSFER_QUALITY_REP_OPTIONS = [
  { label: "AE", value: "AE" },
  { label: "SDR", value: "SDR" },
];

export const ACTIVITY_COLUMN_DATA: IActivityColumnDataColumn[] = [
  { metric_label: "Skip", metric: "Skip", fixed: false },
  { metric_label: "Release", metric: "Release", fixed: false },
  { metric_label: "Avg Days from Set to Hold", metric: "AvgDialsToSetForEachLead", fixed: false },
  { metric_label: "Avg Time of First Dial", metric: "AvgTimeToFirstDial", fixed: false },
  { metric_label: "Inbound Lead Assignment to First Dial", metric: "InboundLeadAssignmentToFirstDial", fixed: false },
  { metric_label: "Avg Days to Close", metric: "MedianDaysToClose", fixed: false },
  { metric_label: "Avg Days from first dial to contact", metric: "MedianDaysFromFirstDialToContact", fixed: false },
  { metric_label: "Avg Days from contact to set", metric: "MedianDaysFromContactToSet", fixed: false },
  { metric_label: "Avg Days from Hold to Decision Call", metric: "MedianDaysFromHoldToDecisionCall", fixed: false },
  { metric_label: "Avg Days from Hold to Sale", metric: "MedianDaysFromHoldToSale", fixed: false },
  { metric_label: "Avg Days from Dec Call to Sale", metric: "MedianDaysFromDecisionCallToSale", fixed: false },
  { metric_label: "Call Coaching Requests", metric: "CallCoachingRequests", fixed: false },
  { metric_label: "Call Requests Received", metric: "ReviewsReceived", fixed: false },
  { metric_label: "# of self sourced leads", metric: "SelfSourcedLeads", fixed: false },
  { metric_label: "# of Transfers", metric: "Transfers", fixed: false },
];
